import { AsideMenuActionItem } from "./AsideMenuActionItem"
import { AsideMenuItemWithSub } from "../../../../layout/components/aside/AsideMenuItemWithSub"
import { IPageAction } from "../../../base/models"
import { useGetProperties } from "../../../base/hooks"
import { Property } from "../../../base/types"

export const AsideMenuActionGroup = ({ action, className }: {
    action: IPageAction,
    className?: string
}) => {
    const { properties } = useGetProperties({ bindings: action.bindings });
    const hide: boolean = properties[Property.IsChecked];
    const { actions } = action

    if (hide) return <></>

    return <>
        <AsideMenuItemWithSub
            to=''
            className={className}
            title={action.name}
            fontIcon='bi-chat-left'
            materialIcon={action.icon}>

            {actions?.map(action => (
                <AsideMenuActionItem
                    key={action.actionId}
                    hasBullet={true}
                    className={'fs-8 py-1'}
                    action={action} />
            ))}

        </AsideMenuItemWithSub>
    </>
}